import {useEffect, useState} from "react";

function useQueryParam(effect: (params: any) => void) {

    const [params, setParams] = useState({})

    useEffect(() => {
        const params = new URLSearchParams(document.location.search);
        // const entries: any = new URLSearchParams(document.location.search).entries()
        const result: any = {}
        // @ts-ignore
        const keys = [...params.keys()||[]];
        for(const key of keys){
            const value = params.getAll(key);
            result[key] = value.length>1 ?params.getAll(key):params.get(key)
        }
        effect(result)
    }, [])

    return params
}

export default useQueryParam
